module.exports = __webpack_public_path__ + "img/uploadicon.8f738aea.svg";